<template>
  <div id="app">
    <ProgressBar></ProgressBar>
    <component
      v-for="(chapter, index) in chapters"
      :key="index"
      :is="chapter.component"
      :track="chapter.track"
    ></component>
  </div>
</template>

<script>
import ProgressBar from './components/ProgressBar'
import { Intro, Chapter1, Chapter2, Chapter3, Chapter4, Chapter5, Chapter6, Hulp, Colofon } from './components/chapters'

export default {
  name: 'App',
  data () {
    return {
      chapters: [].concat({
        component: Intro,
        track: '00-intro'
      },
      {
        component: Chapter1,
        track: '01-opstaan'
      },
      {
        component: Chapter2,
        track: '02-naar-buiten'
      },
      {
        component: Chapter3,
        track: '03-social-media'
      },
      {
        component: Chapter4,
        track: '04-vrienden'
      },
      {
        component: Chapter5,
        track: '05-alleen-zijn'
      },
      {
        component: Chapter6,
        track: '06-uit-het-dal'
      },
      {
        component: Hulp,
        track: '07-hulp'
      },
      {
        component: Colofon,
        track: '08-colofon'
      })
    }
  },
  components: {
    ProgressBar
  }
}
</script>

<style lang="scss">
  @import "./assets/scss/style.scss";

  #app {
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue